export default __webpack_public_path__ + "static/media/caret.041ce8a4.svg";